import GlobalHeader from "../components/organisms/GlobalHeader";
import { useQueryString } from "../hooks/useQueryString";
import OperatorInterface from "../interfaces/OperatorInterface";
import { SectionStateInterface } from "../interfaces/SectionInterface";

export type GlobalHeaderProps = {
  currentSection: SectionStateInterface;
  currentOperator: OperatorInterface | null;
  operators: OperatorInterface[];
  onSearchStudent: (studentNameFilter: {
    firstName: string;
    lastName: string;
  }) => void;
};

const SectionGlobalHeader = (props: GlobalHeaderProps) => {
  const query = useQueryString();

  if (!props.currentSection.data || !props.currentOperator) {
    return null;
  }

  return (
    <GlobalHeader
      section={props.currentSection.data}
      operators={props.operators}
      currentOperator={props.currentOperator}
      studentNameFilter={{
        firstName: query.first_name,
        lastName: query.last_name,
      }}
      onSearchStudent={props.onSearchStudent}
    />
  );
};

export default SectionGlobalHeader;
